export const backendServerIP = window.location.origin
